import styled from "styled-components";
import { tokens } from "@manifesthhqinc/ui-library";

export const ListContainerDiv = styled.ul<{
  $padding?: string;
  $backgroundColor?: string;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 6px;

  padding: ${({ $padding }) => `${$padding || "0px"}`};
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    `background: ${$backgroundColor};
   box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.05);`}
`;

export const ListItem = styled.li<{
  $paddingLeft?: string;
  $paddingRight?: string;
  $maxWidth: string;
}>`
  width: 100%;
  max-width: ${(props) => props.$maxWidth};
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  padding-left: ${({ $paddingLeft }) => `${$paddingLeft || 0}px`};
  padding-right: ${({ $paddingRight }) => `${$paddingRight || 0}px`};
`;

// iconSpacing allows additional spacing between icon and content
export const ListItemIcon = styled.div<{ $iconSpacing?: string }>`
  flex-basis: ${({ $iconSpacing }) => ($iconSpacing ? `${$iconSpacing}px` : "35px")};
  height: 31px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    height: 35px;
    object-fit: contain;
  }
`;

export const ListItemContent = styled.div<{
  $withBody: boolean;
  $size?: "large" | "medium";
}>`
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;
  ${(props) =>
    props.$size !== "large"
      ? `
  .heading {
    color: ${tokens.color.text[1000]};
    font-size: 16px;
    min-height: 31px;
    line-height: 24px;
    display:flex;
    align-items:center;
  }`
      : `gap:4px;`}

  .body {
    color: ${tokens.color.text.secondary};
    font-size: 14px;
    line-height: 1.5;
    max-width: 232px;
  }

  ${(props) =>
    !props.$withBody &&
    `
      min-height:26px;
      `}

  a {
    text-decoration: underline;
    color: ${tokens.color.brand[700]};
  }
`;
